<s18-scorecard-lookup [course_id]="course_id" [inModal]="true" (close)="close()"></s18-scorecard-lookup>
